import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import TokenService from "@/services/token";

export function useIdleLogout(timeoutMinutes = 15) {
  const router = useRouter()
  const store = useStore();

  const timeoutMs = timeoutMinutes * 60 * 1000
  let timer = null

  const resetTimer = async () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(async () => {
      if (store.getters.getProfile) {
        TokenService.removeAccessToken();
        await store.dispatch('fetchUpdateAuth', false);
        localStorage.clear();
        await router.push({ name: 'login' });
      }
    }, timeoutMs)
  }

  const events = [
    'mousemove',
    'mousedown',
    'keydown',
    'scroll',
    'touchstart',
    'click',
    'wheel'
  ]

  const handleActivity = async () => {
    await resetTimer()
  }

  onMounted(async () => {
    await resetTimer()
    events.forEach(event => {
      window.addEventListener(event, handleActivity)
    })
  })

  onUnmounted(() => {
    if (timer) clearTimeout(timer)
    events.forEach(event => {
      window.removeEventListener(event, handleActivity)
    })
  })

  return { resetTimer }
}